// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import '../globals';

export const environment = {
  production: false,
  fullVersion: __BRANCH_NAME__ && __COMMIT_HASH__ ? `${__BRANCH_NAME__}-${__COMMIT_HASH__}` : __BRANCH_NAME__,
  version: __APP_VERSION__,
  environment: __ENVIRONMENT__,
  oauth: {
    clientIds: {
      outlook: 'outlook-365-addin',
      word: 'word-365-addin',
      excel: 'excel-365-addin',
      widget: 'ftf-inlay',
    },
  },
  pendo: {
    key: __PENDO_KEY__,
    url: __PENDO_URL__,
    otKey: __OTI_KEY__,
    cname: {
      content: __CNAME_CONTENT__,
      data: __CNAME_DATA__,
    },
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
